import { render } from "./Terminos.vue?vue&type=template&id=257a0945"
import script from "./Terminos.vue?vue&type=script&lang=js"
export * from "./Terminos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__